import React, { useEffect, useState } from 'react';
import api from '../../api';
import './SUPPullListReport.css';
import '../Buttons.css'


const SUPPullListReport = ({ currentSupplier }) => {
    const [batches, setBatches] = useState([]); 
    const [selectedBatchName, setSelectedBatchName] = useState(null);
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [status, setStatus] = useState('');

    // ------------------------------------------------------------
    // Load list of batches for this supplier
    // ------------------------------------------------------------
    useEffect(() => {
        const fetchBatches = async () => {
            try {
                setLoading(true);
                const res = await api.get(`/supplierReport/pullListBatches/${currentSupplier.id}`);
                setBatches(res.data || []);
                setStatus('');
            } catch (err) {
                console.error('Error fetching pull list batches:', err);
                setStatus('Error loading batches.');
            } finally {
                setLoading(false);
            }
        };

        fetchBatches();
    }, [currentSupplier.id]);

    // ------------------------------------------------------------
    // Load pull sheet for selected batch
    // ------------------------------------------------------------
    useEffect(() => {
        if (!selectedBatchName) return;

        const fetchPullList = async () => {
            try {
                setLoading(true);

                let res;

                //special mode: pull from store inventory
                if (selectedBatchName ==="__STORE__") {
                    res = await api.get(`/supplierReport/pullListStore/${currentSupplier.id}`);
                }
                //normal mode: pull for a batch
                else {
                    await api.get(`/supplierReport/pullList/${currentSupplier.id}/${selectedBatchName}`);
                }
                setItems(res.data || []);
                setStatus('');
            } catch (err) {
                console.error('Error fetching pull list:', err);
                setStatus('Error loading pull list.');
            } finally {
                setLoading(false);
            }
        };

        fetchPullList();
    }, [selectedBatchName, currentSupplier.id]);

    return (
        <div className="supplier-pull-list-report">
            <h3>Pull Sheet</h3>

            {loading && <p>Loading�</p>}
            {status && <p className="status-message">{status}</p>}

            {/* ------------------------------------------------------------
                MASTER VIEW: List of batches
            ------------------------------------------------------------ */}
            {!loading && !selectedBatchName && (
                <>
                        <table className="matrix-grid pull-sheet-table">
                            <thead>
                                <tr>
                                    <th>Batch</th>
                                    <th>Order Date</th>
                                </tr>
                            </thead>

                            <tbody>

                                {/* SPECIAL ROW: Pull From Store Inventory */}
                                <tr
                                    key="__STORE__"
                                    onClick={() => setSelectedBatchName("__STORE__")}
                                    style={{ 
                                        cursor: 'pointer',
                                        fontWeight: 'bold',
                                        backgroundColor: '#f5f5f5'
                                    }}
                                >
                                    <td>Pull From Store Inventory</td>
                                    <td>-</td>
                                </tr>

                                {/* EXISTING BATCH ROWS */}
                                {batches.map(b => (
                                    <tr
                                        key={b.batchName}
                                        onClick={() => setSelectedBatchName(b.batchName)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <td>{b.batchName}</td>
                                        <td>{new Date(b.orderDate).toLocaleDateString()}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                </>
            )}

            {/* ------------------------------------------------------------
                DETAIL VIEW: Pull sheet for selected batch
            ------------------------------------------------------------ */}
            {!loading && selectedBatchName && (
                <>
                    <button className="button" onClick={() => setSelectedBatchName(null)}>
                        Back to Batches
                    </button>

                    <button
                        className="button"
                        style={{ marginLeft: '10px' }}
                        onClick={() => window.print()}
                    >
                        Print Pull Sheet
                    </button>

                    <h4>Batch {selectedBatchName}</h4>

                    {items.length === 0 && <p>No items to pull.</p>}

                    {items.length > 0 && (
                        <table className="matrix-grid pull-sheet-table">
                            <thead>
                                <tr>
                                    <th>Crop</th>
                                    <th>Variety</th>
                                    <th>Total Packets</th>
                                </tr>
                            </thead>

                            <tbody>
                                {items.map((row, idx) => (
                                    <tr key={idx}>
                                        <td>{row.crop}</td>
                                        <td>{row.varietyName}</td>
                                        <td>{row.totalUnits}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </>
            )}
        </div>
    );
};

export default SUPPullListReport;
